import React, { Component } from "react";
import Select from "react-select";

// Components
import GeneralLoader from "../../../GeneralLoader";
import ErrorWrap from "../../../utils/error-success/ErrorWrap";

class MailingLocationFieldset extends Component {
	constructor(props) {
		super(props);

		this.dataProps = [
			"mailing_address",
			"mailing_address_2",
			"mailing_city",
			"mailing_postal",
			"mailing_province"
		];
		this.miscProps = ["errors", "locationsError", "locationsLoading", "provinces", "inProcess"];
	}

	shouldComponentUpdate(nextProps) {
		// Check local props to see if any have changed
		const dataPropResults = this.dataProps.some(prop => {
			return this.props.data[prop] !== nextProps.data[prop];
		});
		const miscPropResults = this.miscProps.some(prop => {
			return this.props[prop] !== nextProps[prop];
		});

		// If any local props changed, we will rerender
		return dataPropResults || miscPropResults;
	}

	render() {
		const { data, errors, locationsError, locationsLoading, provinces, inProcess } = this.props;

		return (
			<div className="fieldset">
				<div className="title-label">Mailing Location</div>
				<div className="fieldset-indent">
					<div className="form-field">
						<label>Mailing Address:</label>

						{!!errors.mailing_address && (
							<ErrorWrap animate={1}>{errors.mailing_address}</ErrorWrap>
						)}
						<input
							type="text"
							id="mailing_address"
							value={data.mailing_address}
							maxLength="255"
							disabled={inProcess}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
						/>
					</div>

					<div className="form-field">
						<label>Mailing Address 2:</label>

						{!!errors.mailing_address_2 && (
							<ErrorWrap animate={1}>{errors.mailing_address_2}</ErrorWrap>
						)}
						<input
							type="text"
							id="mailing_address_2"
							value={data.mailing_address_2}
							maxLength="255"
							disabled={inProcess}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
						/>
					</div>

					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Mailing City:</label>

							{!!errors.mailing_city && (
								<ErrorWrap animate={1}>{errors.mailing_city}</ErrorWrap>
							)}
							<input
								type="text"
								id="mailing_city"
								value={data.mailing_city}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
						<div className="form-field half-field">
							<label>Mailing Postal</label>

							{!!errors.mailing_postal && (
								<ErrorWrap animate={1}>{errors.mailing_postal}</ErrorWrap>
							)}
							<input
								type="text"
								id="mailing_postal"
								value={data.mailing_postal}
								maxLength="9"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={event => this.props.handleInputChange(event)}
							/>
						</div>
					</div>

					{locationsError ? (
						<ErrorWrap>{locationsError}</ErrorWrap>
					) : locationsLoading ? (
						<GeneralLoader />
					) : (
						<div className="floated-field-container">
							<div className="form-field half-field">
								<label htmlFor="province">Mailing Province:</label>

								{!!errors.mailing_province && (
									<ErrorWrap animate={1}>{errors.mailing_province}</ErrorWrap>
								)}

								<Select
									classNamePrefix="react-select"
									placeholder={"Select one"}
									isClearable={false}
									isDisabled={inProcess}
									name={`mailing_province`}
									value={provinces.filter(
										({ abbreviation }) => abbreviation === data.mailing_province
									)}
									onChange={({ abbreviation }) => {
										this.props.updateSelectedValue(
											abbreviation,
											"mailing_province"
										);
									}}
									options={provinces}
									getOptionLabel={({ name }) => name}
									getOptionValue={({ abbreviation }) => abbreviation}
								/>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default MailingLocationFieldset;



// WEBPACK FOOTER //
// ./src/components/admin/organizations/form-components/MailingLocationFieldset.js